var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "GmapMap",
        {
          ref: "mapRef",
          staticClass: "map",
          style: "height: " + _vm.height,
          attrs: {
            options: {
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: true,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: true,
              disableDefaultUi: false
            },
            center: _vm.center,
            zoom: _vm.zoom,
            "map-type-id": "terrain"
          }
        },
        _vm._l(_vm.markers, function(m, index) {
          return _c(
            "gmap-custom-marker",
            {
              key: index,
              attrs: { offsetY: -10, "z-index": 1, marker: m, alignment: "top" }
            },
            [_c("CustomGenericMarker", { attrs: { value: m.title } })],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-44812d10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44812d10","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/CustomGoogleMap.vue
// module id = null
// module chunks = 